import ReportingManager from "./Container"

export default ReportingManager
